export default {
      id: "ic_confirm_check_green-usage",
      viewBox: "0 0 56 56",
      url: "/" + "images/icons.3.109.2.svg#ic_confirm_check_green-usage",
      toString: function () {
        return this.url;
      }
    }